/**
 * Pantalla: Guia
 * Component: PantGuiaI.tsx
 * Llenguatge: TypeScrypt
 * Autors: Jordi Riu
 * Versió: 1.1
 * Data: 19/12/2017
 * (c) Ajuntament de Manresa - dic 2017 - Departament de Sistemes d'Informació
 * Versió incristable i sense funcionalitat del mapa guia
 */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { MapComponent } from '@terrestris/react-geo';
// import OlLayerImage from 'ol/layer/Image';
// import OlImageSource from 'ol/source/Image';
// import OlLayerTile from 'ol/layer/Tile';
// import OlTileSource from 'ol/source/Tile';
import { IPropsMapa } from '../interfaces/IPropsMapa';
import GuiaState from '../states/GuiaState';
// import MyLayerSwitcher from '../controls/MyLayersSwitcher';
// import MyLayerSwitcher2 from '../controls/MyLayersSwitcher2';
// import MyZoomToExtent from '../controls/MyZoomToExtent';
// import MyCustomControl from '../controls/MyCustomControl';
import 'ol/ol.css';
import 'antd/dist/antd.min.css';
import '../css/react-geo.css';
import '../css/MyControls.css';
import '../css/Mapa.css';
import '../css/Guia.css';
// import { FullscreenExitOutlined } from '@ant-design/icons'
// import { GpsFixed } from '@material-ui/icons';
// import { ILayer } from '../interfaces/ILayer';

@inject('appState')
@observer
export default class PantGuia extends React.Component<IPropsMapa, object> {
    constructor(props: IPropsMapa) {
        super(props);
        // Creem el mpState - Els paràmetres el processem dins de createMap de GuiaState
        this.gState = new GuiaState(this.props);

        // Events pel canvi de mida de la pantalla
        if (this.props.match.params.width && this.props.match.params.height) {
            this.gState.width = parseInt( this.props.match.params.width);
            this.gState.height = parseInt(this.props.match.params.height);
        } else {
            this.gState.updateWindowSize();
            this.autoSize = true;
        }
    }
 
    // El estat del mapa
    private gState: GuiaState;
 
    // Diu si agafem les mides de la pantalla
    private autoSize = false;
    private readonly resizeHandler = this.updateDimensions.bind(this);

    updateDimensions() {
        if (this.autoSize) {
            this.gState.updateWindowSize();
        }
    }
    
    // Per posar si cal la resposta a l'event de resize
    componentDidMount() {
        if (this.autoSize) {
            window.addEventListener('resize', this.resizeHandler);
        }
    }
      
    // Per treure si cal la resposta a l'event de resize
    componentWillUnmount() {
        if (this.autoSize) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    }
    
    // // Hem canviat de BaseLayer
    // private handleBaseLayerChanged = (layerSelected: OlLayerTile<OlTileSource> | OlLayerImage<OlImageSource>) => {
    //    this.gState.actBaseLayer = layerSelected;
    //    // La capa de noms només la volem activa als layers de Planejament i Ortofoto
    //     if (this.gState.nomsLayer) {
    //         const id: string = layerSelected.get('id');
    //         const ld: ILayer = this.gState.mapConfig.baseLayers.find((l: ILayer) => l.id === id);
    //         if (ld && ld.noms) {
    //            this.gState.nomsLayer.set('visible', this.gState.nomsVisible);
    //            this.gState.setShowNoms(true);
    //         } else {
    //            this.gState.nomsLayer.set('visible', false);
    //            this.gState.setShowNoms(false);
    //         }
    //     }
    // }
 
    // // Anar a la posició actual del mòbil
    // private handleGotoMyLocation = () => {
    //     this.gState.setActualLocation();
    // }

    // // Recentrar mapa
    // private handleMyCenterPosition = () => {
    //     this.gState.zoomToPosition();
    // }
    
    render () {
        if (!this.gState.configOk) {
            return null;
        }

        if (this.gState.scalectl) {
            this.gState.olmap.removeControl(this.gState.scalectl);
            this.gState.scalectl = null;
        }
        const w: number = this.gState.width; // Amplada de la finestra
        const wx: string = w.toString() + 'px'; // Amplada del mapa

        const mto = '0px'; // Posició top del mapa
        const h: number = this.gState.height; // Alçada del mapa
        const hx: string = h.toString() + 'px'; // Alçada del mapa

        // const lx = '.5em'; // : string = w < 601 ? '.5em' : 'calc(50% - ' + ((w / 2) - 270) + 'px)'; // Esquerra del layer switcher
        // const bx = 'calc(100% - ' + (h - 10).toString() + 'px)'; // ': string = calc(100% - ' + (h + ( w < 601 ? 80 : 90)).toString() + 'px)'; // Bottom del layer switcher

        return (
            <>
                {this.gState.olmap && <MapComponent map={this.gState.olmap} style={{width: wx, height: hx, cursor: this.gState.identPosition ? 'crosshair' : this.gState.identElement ? 'pointer' : 'default', position: 'fixed', top: mto}}/>}
                {/*}
                {this.gState.olmap && <MyZoomToExtent map={this.gState.olmap} tooltip="Zoom total" extent={this.gState.mapConfig.initialExtent}/>}
                {this.gState.olmap && <MyCustomControl
                    map={this.gState.olmap} 
                    className="my-1-position" 
                    icon={GpsFixed}
                    tooltip="Anar a la posició actual"
                    onClick={this.handleGotoMyLocation}
                    key="mycc1"
                />}
                {this.gState.olmap && !!this.gState.position && <MyCustomControl
                    map={this.gState.olmap} 
                    className="my-5-position" 
                    icon={FullscreenExitOutlined} 
                    tooltip="Centrar el mapa al marcador"
                    onClick={this.handleMyCenterPosition}
                    hidden={!this.gState.position}
                    key="mycc5"
                />}
                {this.gState.baseLayers.length === 2 && <MyLayerSwitcher
                    style={{
                        position: 'absolute',
                        bottom: bx,
                        left: lx,
                        zIndex: 2
                    }}
                    map={this.gState.olmap}
                    layers={this.gState.baseLayers}
                    onBaseLayerChanged={this.handleBaseLayerChanged}
                    key="myls1"
                />}
                {this.gState.baseLayers.length > 2 && <MyLayerSwitcher2 
                    style={{
                        position: 'absolute',
                        bottom: bx,
                        left: lx,
                        zIndex: 2,
                        backgroundColor: 'rgba(250, 250, 250, 0.8)'
                    }}
                    map={this.gState.olmap}
                    layers={this.gState.baseLayers}
                    onBaseLayerChanged={this.handleBaseLayerChanged}
                    key="myls2"
                />}
                */}
            </>
        );
    }
}